module.exports = __webpack_public_path__ + "static/media/b11-城隍庙.d6e59818.png";